import { FC } from 'react';
import { AccordionItemContentType } from '../../api/types';

interface Props {
  content: AccordionItemContentType[];
}

const AccordionDefaultBody: FC<Props> = ({ content }) => {
  return <div className="fs-caption-reg text-mako pt-2 pb-2">{content}</div>;
};

export default AccordionDefaultBody;
